import React, {
  createContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

// Colors are shared with mobile via @learnzapp/core/theme (single source of
// truth). getColorTheme defaults to the web platform alias layer.
import { getColorTheme } from "@learnzapp/core/theme";
import { DEFAULT_THEME_MODE, BRAND_THEME } from "../utils/brandFlags";


export const ThemeContext = createContext();

// New users (no saved `Theme`) get the brand default (white-label brands set DEFAULT_THEME_MODE,
// e.g. Training Camp = 'dark'); the trailing 'dark' preserves the prior default for brands that
// don't set it. A user who has toggled keeps their saved choice.
const resolveInitialTheme = () =>
  localStorage.getItem("Theme") || DEFAULT_THEME_MODE || "dark";

export const ThemeProvider = (props) => {
  // Lazy-init from the resolved default so there's no light-mode flash before the effect runs.
  const [currentTheme, setCurrentTheme] = useState(resolveInitialTheme);
  useEffect(() => {}, [localStorage.getItem("SAVED_BUNDLE_DETAILS")]);
  const currentThemeRef = useRef(null);
  currentThemeRef.current = currentTheme;

  // Apply the body `dark` class before first paint (covers Tailwind dark: variants).
  useLayoutEffect(() => {
    document.body.classList.toggle("dark", resolveInitialTheme() === "dark");
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("Theme") || DEFAULT_THEME_MODE || "dark";
    const body = document.body;
    if (theme === "light") {
      setCurrentTheme("light");
      body.classList.remove("dark");
    } else if (theme === "dark") {
      setCurrentTheme("dark");
      body.classList.add("dark");
    }
    getTheme();
  }, [currentTheme]);

  async function setAppTheme(mode) {
    setCurrentTheme(mode);
    // UPDATE_USER_THEME(mode);
  }

  function getThemeName() {
    
    return currentTheme;
  }

  function getTheme() {
    // Only "dark" selects the dark theme; "system" (until OS detection lands),
    // "light", and anything unexpected resolve to light — same mapping as before.
    const mode = currentTheme === "dark" ? "dark" : "light";
    return getColorTheme(mode, "web", BRAND_THEME);
  }

  useEffect(() => {}, [currentTheme]);

  const theme = getTheme();
  return (
    <ThemeContext.Provider
      value={{
        theme,
        currentTheme,
        setCurrentTheme,
        setAppTheme,
        getThemeName,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};
